const buildUserQueryProps = userProps => {
  if (!userProps || !userProps.length) return '';
  const basicProps = [];
  const nestedProps = {};
  userProps.forEach(({
    propertiesToDisplay
  }) => {
    const [propKey] = propertiesToDisplay;
    if (!propKey || propKey === 'id') return;
    if (propKey.indexOf('.') !== -1) {
      const [baseProp, nestedProp] = propKey.split('.');
      if (nestedProps[baseProp]) nestedProps[baseProp].push(nestedProp);else nestedProps[baseProp] = [nestedProp];
    } else basicProps.push(propKey);
  });
  Object.keys(nestedProps).forEach(nestedKey => {
    const nested = nestedProps[nestedKey];
    basicProps.push(nestedKey);
    basicProps.push('{');
    nested.forEach(prop => basicProps.push(prop));
    basicProps.push('}');
  });
  return basicProps.join(' ');
};
export default buildUserQueryProps;
//# sourceMappingURL=build-user-query-props.js.map